<template>
  <el-dialog title="客服工作时间" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
      <el-form-item label="工作时间：" prop="chaptersNum">
        <el-select v-model="form.content" placeholder="请选择">
          <el-option label="每天" value="10"></el-option>
          <el-option label="工作日" value="20"></el-option>
        </el-select>
        <el-time-picker v-model="form.content1" format="HH:mm" start-placeholder="开始" end-placeholder="结束" placeholder="选择时间范围" is-range></el-time-picker>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>

import sysDataconstantApi from '@/api/config/sysDataconstant'
import { formatDate, formatDTime } from '@/utils/index'
export default {
  data() {
    return {
      form: {},
      formVisible: false,
      formRules: {
        content: [{ required: true, message: '请选择工作时间', trigger: 'change' }],
        content1: [{ required: true, message: '选择时间范围', trigger: 'change' }]
      },
    }
  },
  created() {

  },
  methods: {
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row };
      let time = row.content1.split('-')
      let date = formatDate(new Date())
      this.$set(this.form, 'content1', [`${date} ${time[0]}`, `${date} ${time[1]}`])
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      let params = JSON.parse(JSON.stringify(this.form))
      let { content1 } = params;
      let time1 = formatDTime(content1[0])
      let time2 = formatDTime(content1[1])
      params.content1 = `${time1} - ${time2}`
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          sysDataconstantApi.update(params).then((data) => {
            this.postCallback(data)
          });
        }
      });
    },
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
